import {NgModule, Optional, SkipSelf} from '@angular/core';
import { CommonModule } from '@angular/common';

import { NbinputSignComponent } from './nbinput-sign.component';
import {NbinputTextComponent} from "./nbinput-text.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NbinputLabelComponent} from "./nbinput-label.component";
import {DpDatePickerModule} from "ng2-date-picker";
import {NbinputDateComponent} from "./nbinput-date.component";
import {NbinputOptionComponent} from "./nbinput-option.component";
import {NbinputFilesizePipe} from "./nbinput-filesize.pipe";
import {NbinputFileComponent} from "./nbinput-file.component";
import {NbinputImageComponent} from "./nbinput-image.component";
import {NbinputNumberComponent} from "./nbinput-number.component";
import {NbinputUploadService} from "./nbinput-upload";
import {ModalGalleryModule} from "angular-modal-gallery";
import {NbinputGalleryComponent} from "./nbinput-gallery.component";
import {NgSelectModule} from "@nbxx/nb-ng-select";
import {FroalaEditorModule, FroalaViewModule} from "@nbxx/nb-angular-froala";
import {NbinputFroalaComponent} from "./nbinput-froala.component";
import {NbinputConfig} from "./nbinput.entity";
import {NbinputRatingComponent} from "./nbinput-rating.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DpDatePickerModule,
    NgSelectModule,
    ModalGalleryModule,
    FroalaEditorModule,
    FroalaViewModule,
  ],
  declarations: [
    NbinputFroalaComponent,
    NbinputSignComponent,
    NbinputTextComponent,
    NbinputNumberComponent,
    NbinputLabelComponent,
    NbinputDateComponent,
    NbinputFileComponent,
    NbinputImageComponent,
    NbinputOptionComponent,
    NbinputGalleryComponent,
    NbinputRatingComponent,
    NbinputFilesizePipe,
  ],
  providers: [
    NbinputUploadService,
  ],
  exports: [
    NbinputFroalaComponent,
    NbinputSignComponent,
    NbinputTextComponent,
    NbinputNumberComponent,
    NbinputLabelComponent,
    NbinputDateComponent,
    NbinputFileComponent,
    NbinputImageComponent,
    NbinputOptionComponent,
    NbinputGalleryComponent,
    NbinputRatingComponent,
  ],
})
export class NbinputModule {
  public static forRoot(config: NbinputConfig) {
    return {
      ngModule: NbinputModule,
      providers: [
        {provide: NbinputConfig, useValue: config }
      ]
    };
  }
  constructor (@Optional() @SkipSelf() parentModule: NbinputModule) {
    if (parentModule) {

    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/nbinput/nbinput.module.ts